import { ThemePreference } from '@kirin/api-client/contracts/user-preferences';

export const THEME_PREFERENCES = {
  LIGHT: ThemePreference.Light,
  DARK: ThemePreference.Dark,
  SYSTEM: ThemePreference.System,
} as const;

export const THEME_PREFERENCE_VALUES = {
  LIGHT: ThemePreference.Light,
  DARK: ThemePreference.Dark,
} as const;
